import { NavLink } from "react-router-dom";
import { performLogout, currentUserEmail } from "../auth";

const NAV = [
  { to: "/agents", label: "Agenti", end: false },
  { to: "/skills", label: "Skills", end: true },
  { to: "/memories", label: "Memorie", end: true },
  { to: "/guardrails", label: "Guardrails", end: true },
  { to: "/insights", label: "Insights", end: true },
] as const;

export function AppSidebar() {
  return (
    <aside className="app-sidebar">
      <div className="app-brand">
        <img src="/currents-icon.png" alt="" className="app-brand-icon" width={36} height={36} />
        <div>
          <strong className="app-brand-title">Currents</strong>
          <span className="muted app-brand-sub">Oceany Agents</span>
        </div>
      </div>

      <nav className="app-nav" aria-label="Navigazione principale">
        <ul>
          {NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) => (isActive ? "active" : undefined)}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="app-sidebar-footer">
        <p className="muted app-user">{currentUserEmail() || "Utente"}</p>
        <button type="button" className="secondary" onClick={() => performLogout()}>
          Esci
        </button>
      </div>
    </aside>
  );
}
